import { useTranslation } from 'react-i18next';
import { DocCategory, DOC_CATEGORIES } from './types';

interface DocTypeSelectorProps {
  selected: DocCategory | null;
  onSelect: (category: DocCategory) => void;
  disabled?: boolean;
}

export default function DocTypeSelector({
  selected,
  onSelect,
  disabled = false,
}: DocTypeSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {DOC_CATEGORIES.map((cat) => {
        const isSelected = selected === cat.id;

        return (
          <button
            key={cat.id}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(cat.id)}
            className={[
              'flex flex-col items-center justify-center rounded-2xl p-8 min-h-[200px]',
              'border-2 cursor-pointer transition-all duration-200',
              'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400',
              disabled ? 'cursor-not-allowed opacity-60' : '',
              isSelected
                ? `${cat.borderColor} ${cat.bgColor} scale-[1.02] shadow-lg`
                : 'border-gray-200 bg-white hover:shadow-lg hover:border-gray-300',
            ].join(' ')}
          >
            <span className="text-6xl mb-4" role="img" aria-hidden="true">
              {cat.icon}
            </span>
            <span
              className={[
                'text-xl font-bold mb-2',
                isSelected ? cat.color : 'text-gray-800',
              ].join(' ')}
            >
              {t(cat.titleKey)}
            </span>
            <span className="text-sm text-gray-500 text-center ltr:text-left rtl:text-right">
              {t(cat.descKey)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
